import { Layout, PlantData as PlantDataComponent } from "components"
export const PlantData = () => {
 return (
  <Layout>
   <PlantDataComponent />
  </Layout>
 )
}
